import { render, staticRenderFns } from "./ElectronicDocuments.vue?vue&type=template&id=6a5cf878&scoped=true"
import script from "./ElectronicDocuments.vue?vue&type=script&lang=js"
export * from "./ElectronicDocuments.vue?vue&type=script&lang=js"
import style0 from "./ElectronicDocuments.vue?vue&type=style&index=0&id=6a5cf878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5cf878",
  null
  
)

export default component.exports